// OTC-2693: event images have a display-size twin under resized/<key> in the
// otc-game-images bucket, written by a lambda after upload. Pages load the twin
// through the v-twin-src directive (src/directives/twinSrc.js), which falls back
// to the original if the twin is missing (an image uploaded before the twin job
// ran, or one the job skipped). The directive imports twinUrl from here; the
// orientation mixin uses it to probe the same file the <img> renders.
// The CDN hostname lives in TWIN_HOST and nowhere else; stored URLs never change.
const BUCKET_URL = /^https:\/\/otc-game-images\.s3(?:\.us-east-1)?\.amazonaws\.com\//
const TWIN_PREFIX = 'resized/'
// Twins are served through CloudFront (cdn.offthecouch.io, behaviour resized/* on the
// otc-game-images origin). Originals and the error fallback stay on the bucket URL.
const TWIN_HOST = 'https://cdn.offthecouch.io/'

export function twinUrl(url) {
  if (typeof url !== 'string') return url
  const m = url.match(BUCKET_URL)
  if (!m) return url
  const key = url.slice(m[0].length)
  if (!key) return url
  return TWIN_HOST + (key.startsWith(TWIN_PREFIX) ? key : TWIN_PREFIX + key)
}
